module.exports = __webpack_public_path__ + "static/media/08_atw_weihnachtskarte_rueckseite_ohne_stempel.7ceaff05.svg";